import { useCallback } from "react"
import { getDealScoreData, getDealScoreOfSold } from "@lib/api/listings"
import useSWR from "swr"
import { Listing } from "@t/Listing"
import { AsyncReturnType } from "type-fest"

export function useListingDealScore(listing: Listing, fallbackData?: ReturnType<typeof getDealScoreData>) {
    const fetcher = useCallback(() => {
        return getDealScoreData(listing)
    }, [listing])
    const {
        data: { data: topListings, meta }
    } = useSWR("listingDealScore" + listing.id, {
        fetcher: fetcher,
        refreshInterval: 1000 * 60, // 5 minutes
        fallbackData: fallbackData || { data: [], meta: { pagination: { total: 0, start: 0, limit: 0 } } }
    })
    return { topListings, meta }
}
export function useSoldListings(listing: Listing) {
    const fetcher = useCallback(() => {
        return getDealScoreOfSold(listing)
    }, [listing])
    const {
        data: { meta }
    } = useSWR<AsyncReturnType<typeof getDealScoreOfSold>>("soldListingDealScore" + listing.id, {
        fetcher: fetcher,
        fallbackData: { data: [], meta: { pagination: { total: 0, start: 0, limit: 0 } } }
    })
    return { totalForLastMonth: meta?.pagination?.total || 0 }
}
